import React from 'react';

const AppTitle = () => (
  <div className="sticky top-0 z-10 bg-[#f8f9fa] w-full flex flex-col items-center pt-10 pb-2 select-none">
    <div className="flex items-center justify-center mb-1">
      <span className="material-icons text-blue-500 text-3xl md:text-4xl mr-2">spellcheck</span>
      <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900 tracking-tight">오탈자 닷컴</h1>
    </div>
    <div className="text-base md:text-lg text-gray-600 font-medium">글쓰기의 기본, 신뢰의 시작</div>
  </div>
);

export default AppTitle; 